import { Edit } from 'react-admin'

import MeditationForm from './MeditationForm'

const MeditationEdit = props => {
  return (
    <Edit undoable={false} {...props}>
      <MeditationForm permissions={props.permissions} />
    </Edit>
  )
}

export default MeditationEdit
